import * as React from 'react';
import { FrontLayout } from 'client/ui/layout/FrontLayout';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button } from 'antd';
import { useCurrentCitizen } from 'client/components/auth/AuthModule';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { ProcedureApi } from 'client/components/schema/procedures/ProcedureApi';
import { LoadingPage } from 'client/ui/loader/LoadingPage';
import { AlertPage } from 'client/ui/alert/AlertPage';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';
import { useBreadcrumbItem } from 'client/core/router/breadcrumb/BreadcrumbContext';
import { ProcedureMachine } from 'common/schema/ProcedureMachine';
import { ProcedureViewMainColumn } from './shared/ProcedureViewMainColumn';
import { ProcedureViewSummaryColumn } from './shared/ProcedureViewSummaryColumn';
import { SecondaryText } from 'client/ui/display/text/SecondaryText';
import { RequestApi } from 'client/components/schema/requests/RequestApi';
import { PageFullRow } from 'client/ui/layout/page/PageFullRow';
import { UserLoginButtons } from 'client/components/auth/login/UserLoginButtons';
import { ProcedureViewSummaryActions } from './summary/ProcedureViewSummaryActions';

interface Params {
  id: string;
}

export interface ProcedureViewPageProps extends RouteComponentProps<Params> {}

/**
 * Pagina principale della Domanda frontend
 * contiene la descrizione e i dati generali
 */
export function ProcedureViewPage(props: ProcedureViewPageProps) {
  const id =
    props.match.params.id && props.match.params.id !== 'create'
      ? parseInt(props.match.params.id, 10)
      : null;

  const citizen = useCurrentCitizen();
  const { response, error, loading, refetch } = useApiQuery(
    ProcedureApi.frontend.find,
    {
      skip: id == null,
      data: {
        id: id!
      }
    }
  );

  const requestStateResponse = useApiQuery(RequestApi.getState, {
    skip: id == null,
    data: {
      procedureId: id!
    }
  });
  const requestState = requestStateResponse.response?.data;

  const procedure = response?.data;
  useBreadcrumbItem({ path: '/', title: `Istanze` });
  useBreadcrumbItem({
    path: props.location.pathname,
    title: procedure?.title ?? '...'
  });

  const isSendable = ProcedureMachine.allows(procedure, 'citizen.send');

  if (error || requestStateResponse.error)
    return (
      <AlertPage
        showIcon
        type="error"
        message="Impossibile caricare la domanda"
        description={getNetworkErrorMessage(error)}
      />
    );

  if (!procedure || loading || requestStateResponse.loading)
    return <LoadingPage />;

  return (
    <FrontLayout>
      <PageFullRow>
        {/* Colonna Principale */}
        <ProcedureViewMainColumn procedure={procedure} />

        {/* Colonna Sommario / Azioni  */}
        <ProcedureViewSummaryColumn procedure={procedure}>
          {/* Pulsanti di Azione / Navigazione della Domanda */}
          <ProcedureViewSummaryActions
            isSendable={isSendable}
            citizen={citizen}
            procedure={procedure}
            requestState={requestState}
          />
        </ProcedureViewSummaryColumn>
      </PageFullRow>
    </FrontLayout>
  );
}
